'use strict';

(function() {
  const module = angular.module('client.components');

  controller.$inject = ['$scope', '$route', '$location', 'ExperienceNavigator', 'ExperienceStatusFactory', 'User'];

  function controller($scope, $route, $location, ExperienceNavigator, ExperienceStatusFactory, User) {
    const ctrl = this;
    const routeParams = $route.current && $route.current.params
      ? $route.current.params
      : {};
    ctrl.classId = routeParams.classId;
    const currentCourse = $route.current && $route.current.locals && $route.current.locals.currentCourse;
    ctrl.className = ctrl.classId && currentCourse
      ? currentCourse.custom_name || currentCourse.class_name
      : undefined;
    ctrl.schoolId = routeParams.schoolId;
    ctrl.districtId = routeParams.districtId;
    ctrl.subscriptionId = routeParams.subscriptionId;
    ctrl.userId = User.getId();
    ctrl.isTeacher = User.getSystemRole() === 'TEACHER';
    
    ctrl.inited = false;
    ctrl.onAssignedInited = function(value) {
      $scope.$apply(function() {
        ctrl.inited = value === true;
      });
    };

    ctrl.onNavigateToExperience = function(params) {
      $scope.$apply(function() {
        const experienceId = params && params.experienceId;
        if (!experienceId) {
          return;
        }

        const location = !ctrl.isTeacher
          ? '/experience/' + experienceId + '/activity/scene/0'
          : '/experience/' + experienceId + '/dashboard/responses';
        const back = buildContextBackPath(routeParams);
        ExperienceNavigator.setPreview(false);
        ExperienceNavigator.navigateToExperience(location, "", back);
      });
    };

    ctrl.onEndNowExperience = function(params) {
      $scope.$apply(function() {
        const experienceId = params && params.experienceId;
        if (!experienceId) {
          return;
        }

        const endDate = new Date().toISOString();
        ExperienceStatusFactory.end({
          id: experienceId,
          ends_at: endDate
        });
      });
    };

    ctrl.onReactivateExperience = function(params) {
      $scope.$apply(function() {
        const experienceId = params && params.experienceId;
        if (!experienceId) {
          return;
        }

        const endDate = window.moment().add(1, 'day').toString();
        ExperienceStatusFactory.reactivate({
          id: experienceId,
          ends_at: endDate
        });
      });
    };

    ctrl.onAddExperience = function() {
      $scope.$apply(function() {
        $location.path(buildContextLibraryPath(routeParams));
      });
    };
  }

  function hasRouteParam(value) {
    return value !== undefined && value !== null && value !== '';
  }

  function buildContextBackPath(routeParams) {
    if (hasRouteParam(routeParams.classId)) {
      return '/class/' + routeParams.classId;
    }

    if (hasRouteParam(routeParams.districtId) && hasRouteParam(routeParams.subscriptionId)) {
      return '/district/' + routeParams.districtId + '/subscription/' + routeParams.subscriptionId + '/experiences';
    }

    if (hasRouteParam(routeParams.schoolId) && hasRouteParam(routeParams.subscriptionId)) {
      return '/school/' + routeParams.schoolId + '/subscription/' + routeParams.subscriptionId + '/experiences';
    }

    if (hasRouteParam(routeParams.subscriptionId)) {
      return '/subscription/' + routeParams.subscriptionId;
    }

    return '/experience';
  }

  function buildContextLibraryPath(routeParams) {
    if (hasRouteParam(routeParams.classId)) {
      return '/class/' + routeParams.classId + '/library';
    }

    return '/experience/library';
  }

  module.component('xpExperiences', {
    template: require('./experiences.jade'),
    controller,
  });
})();
